import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = { class: "nav nav-tabs nav-line-tabs mb-5 fs-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link active",
  "data-bs-toggle": "tab",
  href: "#kt_tab_pane_1"
}, "All", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  "data-bs-toggle": "tab",
  href: "#kt_tab_pane_2"
}, "Others", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("a", {
  class: "nav-link",
  "data-bs-toggle": "tab",
  href: "#kt_tab_pane_3"
}, "Static", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "nav nav-tabs nav-line-tabs mb-5 fs-6 mx-15"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "card-toolbar" }
const _hoisted_17 = {
  key: 0,
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: "",
  selected: ""
}, "Type", -1)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "card-body pt-0" }
const _hoisted_21 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_22 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "svg-icon svg-icon-3" }
const _hoisted_25 = {
  key: 1,
  class: "btn btn-icon btn-sm",
  style: {"cursor":"default"}
}
const _hoisted_26 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_ChatBox = _resolveComponent("ChatBox")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.filterTickets('qaustionType', undefined))),
                    class: "nav-item"
                  }, _hoisted_8),
                  _createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterTickets('qaustionType', 'other'))),
                    class: "nav-item"
                  }, _hoisted_10),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterTickets('qaustionType', 'static'))),
                    class: "nav-item"
                  }, _hoisted_12)
                ]),
                (_ctx.filterQuery.qaustionType === 'static')
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questionType, (type, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: index,
                          onClick: ($event: any) => (_ctx.filterTickets('typeId', type.id)),
                          class: "nav-item"
                        }, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["nav-link", { active: _ctx.filterQuery.qaustionType === type.id }]),
                            "data-bs-toggle": "tab",
                            href: '#kt_tab_pane_' + (index + 1)
                          }, _toDisplayString(type.name), 11, _hoisted_15)
                        ], 8, _hoisted_14))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.filterQuery.qaustionType !== 'other')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select form-select-solid form-select-sm",
                    "aria-label": "Default select example",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterTickets('quastionId', $event.target.value))),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterQuery.quastionId) = $event))
                  }, [
                    _hoisted_18,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQuestions(), (question) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: question.id,
                        value: question.id
                      }, _toDisplayString(question.nameEn), 9, _hoisted_19))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.filterQuery.quastionId]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-title": _withCtx(({ row: ticket }) => [
              _createTextVNode(_toDisplayString(ticket.title), 1)
            ]),
            "cell-customerName": _withCtx(({ row: ticket }) => [
              _createTextVNode(_toDisplayString(ticket.customerName), 1)
            ]),
            "cell-quastionName": _withCtx(({ row: ticket }) => [
              _createTextVNode(_toDisplayString(ticket.quastionName), 1)
            ]),
            "cell-status": _withCtx(({ row: ticket }) => [
              (ticket.status)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.translate('Pending')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.translate('Done')), 1))
            ]),
            "cell-actions": _withCtx(({ row: ticket }) => [
              (_ctx.can('remove', 'settings') && ticket.status)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                    onClick: _withModifiers(($event: any) => (_ctx.deleteTicket(ticket)), ["prevent"])
                  }, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/done.svg" })
                    ])
                  ], 8, _hoisted_23))
                : _createCommentVNode("", true),
              (_ctx.can('remove', 'settings') && !ticket.status)
                ? (_openBlock(), _createElementBlock("a", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/done.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("a", null, [
                _createVNode(_component_ChatBox, {
                  id: ticket.id,
                  openDirectly: _ctx.openDirectly
                }, null, 8, ["id", "openDirectly"])
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}